var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 105,
    viewBox: "0 0 102 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9595_45446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6354 82.3655L52.8234 67.356L35.5844 30.3867L24.6926 26.4225L-0.0673828 37.9683L20.6354 82.3655Z",
    fill: "url(#paint0_linear_9595_45446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6943 26.4229L35.5861 30.3871L28.1581 33.8509L24.6943 26.4229Z",
    fill: "url(#paint1_linear_9595_45446)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_9595_45446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3994 71.9304H68.915V31.1394L60.7191 22.9435H33.3994V71.9304Z",
    fill: "url(#paint2_linear_9595_45446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7183 22.9435L68.9142 31.1394H60.7183V22.9435Z",
    fill: "url(#paint3_linear_9595_45446)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_9595_45446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1078 67.3407L81.2958 82.3502L98.5348 45.381L94.5706 34.4893L69.8105 22.9435L49.1078 67.3407Z",
    fill: "url(#paint4_linear_9595_45446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5723 34.4889L98.5365 45.3806L91.1085 41.9169L94.5723 34.4889Z",
    fill: "url(#paint5_linear_9595_45446)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.5642 88.4965C90.5786 88.4965 96.265 82.8101 96.265 75.7956C96.265 68.7811 90.5786 63.0947 83.5642 63.0947C76.5497 63.0947 70.8633 68.7811 70.8633 75.7956C70.8633 82.8101 76.5497 88.4965 83.5642 88.4965Z",
    fill: "url(#paint6_linear_9595_45446)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.2935 69.4445V82.1454C82.2935 82.8465 82.8625 83.4155 83.5635 83.4155C84.2646 83.4155 84.8336 82.8465 84.8336 82.1454V69.4445C84.8336 68.7434 84.2646 68.1744 83.5635 68.1744C82.8625 68.1744 82.2935 68.7434 82.2935 69.4445Z",
    fill: "#0C66E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9172 74.5281H77.2164C76.5153 74.5281 75.9463 75.0971 75.9463 75.7982C75.9463 76.4993 76.5153 77.0683 77.2164 77.0683H89.9172C90.6183 77.0683 91.1873 76.4993 91.1873 75.7982C91.1873 75.0971 90.6183 74.5281 89.9172 74.5281Z",
    fill: "#0C66E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_9595_45446",
    x: 17.0112,
    y: 22.9435,
    width: 68.2921,
    height: 81.7634,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.27764,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_9595_45446"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.55529
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.27764
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9595_45446"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.27764,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_9595_45446"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.3882
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.83293
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_9595_45446",
    result: "effect2_dropShadow_9595_45446"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9595_45446",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_9595_45446",
    x: 32.7197,
    y: 22.9435,
    width: 85.6685,
    height: 92.1832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.27764,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_9595_45446"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.55529
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.27764
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9595_45446"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.27764,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_9595_45446"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.3882
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.83293
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_9595_45446",
    result: "effect2_dropShadow_9595_45446"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9595_45446",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9595_45446",
    x1: 6.63766,
    y1: 34.105,
    x2: 40.0938,
    y2: 84.7424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9595_45446",
    x1: 26.4263,
    y1: 30.1368,
    x2: 33.8542,
    y2: 26.6731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9595_45446",
    x1: 41.1089,
    y1: 22.2759,
    x2: 50.0302,
    y2: 82.3081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9595_45446",
    x1: 60.7184,
    y1: 27.0414,
    x2: 68.9142,
    y2: 27.0414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9595_45446",
    x1: 61.0102,
    y1: 42.0854,
    x2: 90.8546,
    y2: 66.1256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9595_45446",
    x1: 92.8405,
    y1: 38.2029,
    x2: 100.268,
    y2: 41.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA3BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9595_45446",
    x1: 70.9954,
    y1: 62.9931,
    x2: 102.705,
    y2: 68.8891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F3FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9595_45446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 104.885,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoService);
export default __webpack_public_path__ + "static/media/noService.6f191c1babc1208dd25570abd9df3596.svg";
export { ForwardRef as ReactComponent };